// extracted by mini-css-extract-plugin
export default {"footerbox":"index_footerbox_Kex22","cooperation":"index_cooperation_GJ9Ao","ad":"index_ad_7PFva"};